import styles from "./main.module.scss";

interface Props {
  children?: React.ReactNode;
}

const Main: React.FC<Props> = ({ children }) => {
  return (
    <div className={styles.container}>
      <div className={styles.formWrapper}>
        <div>
          <div>
            <img src="/jhu-logo.svg" alt="jhu-logo" />
            <img src="/jhu-name.svg" alt="jhu-name" />
          </div>

          <div>{children}</div>
        </div>
      </div>

      <div className={styles.authImg}>
        <img src="/graduate.png" alt="graduate" />
      </div>
    </div>
  );
};

export default Main;
